import { render, staticRenderFns } from "./videoListPlayer.vue?vue&type=template&id=5cd6c7c7&scoped=true"
import script from "./videoListPlayer.vue?vue&type=script&lang=js"
export * from "./videoListPlayer.vue?vue&type=script&lang=js"
import style0 from "./videoListPlayer.vue?vue&type=style&index=0&id=5cd6c7c7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cd6c7c7",
  null
  
)

export default component.exports